import { subsetByLang } from '../virtuoso/helper';
import settings from "../virtuoso/settings";
const owlResponseHelper = require("../components/graph/owlHelper");

const noIncluded = ["http://hbz.ru/ontologies/emd/AnnotationProperty"];

//var owlResponseHelper = require("../components/graph/owlHelper");
//
//Получение массива списка элементов
//
export const vowl2List= (vowl, baseIri) => {
    const data = []
    const ids = {}
    //Составим список объектов
    if ((vowl)&&(Array.isArray(vowl.classAttribute))){
        //console.log(vowl.classAttribute);
        vowl.classAttribute.map(item => {
            //console.log(item);
            let bi = item.baseIri;
            if (bi && (bi.substr(0, baseIri.length) === baseIri) && (!noIncluded.includes(item.iri))) {
                const element = {key: item.id, name: getName(item), item};
                makeProps(item, element);
                data[data.length]=element;
                ids[item.id] = element;
            }
            //console.log(data);
        })
    }
    return data;
}
const hashCode = s => s.split('').reduce((a,b) => (((a << 5) - a) + b.charCodeAt(0))|0, 0)
//
//Конвертация файла в формате VOWL для отбражения в таблице
// vowl - содержимое онтологии в формате VOWL
// baseIri - "http://hbz.ru/ontologies/emd"
//
export const vowl2Table= (vowl, baseIri) => {
    console.log("emdUtil.js vowl2Table", vowl, baseIri);
    const data = []
    const ids = {}
    //Составим список объектов
    if ((vowl)&&(Array.isArray(vowl.classAttribute))){
        //console.log("emdUtil.js", vowl.classAttribute);
        vowl.classAttribute.map(item => {
            //console.log(item);
            let bi = item.baseIri;
            if (bi && (bi.substr(0, baseIri.length) === baseIri)&& (!noIncluded.includes(item.iri))) {
                const element = {key: item.id, name: getName(item), item, class: true};
                makeProps(item, element);
                data[data.length]=element;
                ids[item.id] = element;
                //Добавим индивидуалы к классам (вложенные элементы)
                if (item.individuals && Array.isArray(item.individuals)){
                    item.individuals.map(ind => {
                        if (!element.children) element.children=[];
                        const child = {key: Math.abs(hashCode(item.id+ind.iri)), name: getName(ind), item: ind, individual: true};
                        makePropsIndividual(ind, child);
                        child.parent = element;
                        element.children[element.children.length] = child;
                    })
                }            
            }
        })
    }
    //Перекомпонуем в соответствии с вложенностью см. superClasses
    //Вложенность фиксируется в children
    //console.log(data);
    data.map(element => {
        if (element.item.superClasses&& Array.isArray(element.item.superClasses)){
            element.item.superClasses.map(id=>{
                const parent = ids[id];
                if (parent){
                    if (!parent.children) parent.children=[];
                    parent.children[parent.children.length] = element;
                    element.parent = parent;
                }
                //console.log("parent", parent);
            })
        }
    })
    const result = data.filter(element => !Array.isArray(element.item.superClasses))
    //console.log(result);
    return result;
}

const getName = item =>{
    if ((item)&&(item.label)){
        if (item.label.ru) return item.label.ru;
        if (item.label.undefined) return item.label.undefined;
        if (item.label.en) return item.label.en;
        if (item.label["IRI-based"]) return item.label["IRI-based"];
    }
    if ((item)&&(item.labels)){
        if (item.labels.ru) return item.labels.ru;
        if (item.labels.undefined) return item.labels.undefined;
        if (item.labels.en) return item.labels.en;
        if (item.labels["IRI-based"]) return item.labels["IRI-based"];
    }
    return item.iri
}

/** Возвращает значение строковой константы для элемента. 
 * определяет по свойству label или labels. Варианты задания
 *
 * "labels" : {"IRI-based" : "HBB","undefined" : "ХББ"}
 * "label" : {"IRI-based" : "OrderedCollection","en" : "Ordered Collection"}, 
 * "labels" : [ {"identifier" : "label", "language" : "undefined", "value" : "Должно быть обязательное указание на поставщика отчёта", "type" : "label"} ], 
 */
export const getNameByLabel = item =>{
    if (item){
        if (item.hasOwnProperty("label")) return getName(item);
        if (item.hasOwnProperty("labels")){
            if (!Array.isArray(item.labels)) return getName(item);
            if (item.labels.length<1) return "not set label";
            return item.labels[0].value;
        }    
    }
    return "null";
}

const makeProps = (item, element) => {
    if (item && item.individuals && Array.isArray(item.individuals)){
        const labels = item.individuals.map(individual=> getName(individual))
        for (let index = 0; index < labels.length; index++) {
            const label = labels[index];
            element.props = (element.props)?element.props+"; "+label:label;
        }
    }
}

const makePropsIndividual = (item, element) => {
    if (item && item.annotations){
        const keys = Object.keys(item.annotations);
        if (keys.includes("Measure")||keys.includes("Dimension")||keys.includes("TimeDimension"))
            element.props = "Свойства объекта: "
        Object.keys(item.annotations).map(key => {
            if (key !="Dimension" && key!="Measure" && key!="TimeDimension") return;
            if (key =="Dimension") element.props = element.props+" Измерения - ";
            if (key =="Measure")  element.props = element.props+" Мера - ";
            if (key =="TimeDimension")  element.props = element.props+" Измерение времени - ";
            if (!Array.isArray(element.annotations))
                element.annotations = [];
            element.annotations.push(item.annotations[key]);
            const labels = item.annotations[key].map(meas=> getName(meas))
            for (let index = 0; index < labels.length; index++) {
                const label = labels[index];
                element.props = element.props+" "+label+"; ";
            }
        })
    }
}

/** Возвращает массив элементов коллективной работы 
 * Элемент вложен в описание аннотации 
 * 
 * Пример элемента (версия с анонимным узлом. Depricate с января 2020.)
 * { "iri" : "http://hbz.ru/ontologies/emd/Agency", "baseIri" : "http://hbz.ru/ontologies/emd","instances" : 0,
 *    "annotations" : {
 *      "teamwork" : [ {"identifier" : "teamwork","language" : "undefined","value" : "_:genid11","type" : "anonymous",
 *        "annotations" : {
 *          "labels" : [ {"identifier" : "label","language" : "undefined", "value" : "Должно быть обязательное указание на поставщика отчёта","type" : "label"} ],
 *          "comments" : [ ],
 *          "description" : [ ],
 *          "deprecated" : false,
 *          "identifierToAnnotation" : {
 *            "implementedBy" : [ {"identifier" : "implementedBy","language" : "undefined","value" : "http://hbz.ru/requrements/00001","type" : "iri"} ]
 *          }
 *        }
 *      } 
 * 
 * 
 * Пример элемента с января 2020. Упрощено для использования при редактировнии в VocBench
 * 		"teamwork": [
 *			{
 *				"identifier": "teamwork",
 *				"type": "literal",
 *				"value": "http://62.61.8.56:8080/web/guest/rqm#/artifacts/30002",
 *				"language": "undefined"
 *			}
 *		],
 *
 */
export const getTeamworks = (selected) =>{
    if (selected && selected.item && selected.item.annotations && selected.item.annotations.teamwork){
        if (Array.isArray(selected.item.annotations.teamwork))
            return selected.item.annotations.teamwork;
        return [selected.item.annotations.teamwork]
    }
    return [];
}

/** Возвращает массив элементов коллективной работы 
 * Элемент вложен в описание аннотации 
 * 
 * Пример элемента с января 2020. Упрощено для использования при редактировнии в VocBench
 *		"wiki": [
 *			{
 *				"identifier": "wiki",
 *				"type": "literal",
 *				"value": "http://62.61.8.56:8080/web/guest/wiki/-/wiki/%D0%93%D0%BB%D0%BE%D1%81%D1%81%D0%B0%D1%80%D0%B8%D0%B9/%D0%9E%D0%BF%D0%B0%D1%81%D0%BD%D1%8B%D0%B9+%D1%85%D0%B8%D0%BC%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%B8%D0%B9+%D1%84%D0%B0%D0%BA%D1%82%D0%BE%D1%80",
 *				"language": "undefined"
 *			}
 *		]
 *
 */
export const getWikies = (selected) =>{
  if (selected && selected.item && selected.item.annotations && selected.item.annotations.wiki){
      if (Array.isArray(selected.item.annotations.wiki))
          return selected.item.annotations.wiki;
      return [selected.item.annotations.wiki]
  }
  return [];
}

/** Вычленить последнее значение в iri, для получения IRI-based */
export const getLastSectionPath = (iri) =>{
  if (iri){
    const lastIndexOf = Math.max(iri.lastIndexOf("#"), iri.lastIndexOf("/"))+1;
    if (lastIndexOf>1) return iri.substring(lastIndexOf);
  }
  return iri;
}

const settingsDefault = {
	//Флаг, что тип определяет родительский класс. Т.е. устанавливается связь rdfs:SubClassOf
	typeAsSuperClass: true,
	//Варианты xxxxxxx_AS_ERROR, xxxxxxx_AS_WARN, xxxxxxx_AS_LOG - вызывают соответствующие сообщения в консоле
	//Доступно:
	// SkipCreateType - сообщение о пропуске создания узла по его типу заданному в массиве objectNoCreated и
	//	и для которого отсутсвет условии исключения из массива settings.createTypes
	// NotSupportedType - сообщение о пропуске создания узла по его типу заданному в объекте триплета и отсутсвующего
	// 	в массиве types и settings.createNodes
	logger: ["SkipCreateType_AS_NONE", "NotSupportedType_AS_NONE"],
	settings: {createTypes:[], createNodes:[]},
};

/**
 * Возвращает Promise, формирующий по триплетам (в ответе SPARQL) структуру в OWL формате
 */
export const newPromiseMakeOWL = (content, settings = settingsDefault) => {
    return new Promise((resolve, reject) => {
        const helper = new owlResponseHelper();
        helper.setResponse(content);
        helper.setConversionSettings(settings);
        resolve(helper.getVOWL());	
    });
}

/**
 * Формирует по результату SPARQL ответа к списку доступных ассетов элементы для временной линии 
 */
export const makeTimelineData = (triplets, lang="ru") => {
    console.log("emdUtil.js makeTimelineData", triplets);
    if (triplets==null) return [];
    return triplets.map(item => { 
        const subset = (item.description)?subsetByLang(item.description, lang, "description"): [];
        const label = (Array.isArray(subset)&&subset.length>0)?subset[0].description.value:"";    
        return {name: item.dsn.value, description: label, IRI: item.IRI.value}
    })
};
